var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "59px",
    viewBox: "0 0 68 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "835BC062-4B80-4707-ACD6-13F878DC6272") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JN-Generation-Letter---Concepts-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Page--Image-Updated-v1-Alt-New-Copy-2",
    transform: "translate(-553.000000, -284.000000)",
    stroke: "#05314D",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Condo-Image-Alt1",
    transform: "translate(75.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(456.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7795636,13.6039273 C45.7795636,6.19156364 39.7701091,0.182109091 32.3577455,0.182109091 C24.9446545,0.182109091 18.9352,6.19156364 18.9352,13.6039273 C18.9352,21.0162909 32.3577455,38.9610182 32.3577455,38.9610182 C32.3577455,38.9610182 45.7795636,21.0162909 45.7795636,13.6039273 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5722182,14.3390545 C38.5722182,17.7717818 35.7896727,20.5543273 32.3576727,20.5543273 C28.9249455,20.5543273 26.1431273,17.7717818 26.1431273,14.3390545 C26.1431273,10.9070545 28.9249455,8.12450909 32.3576727,8.12450909 C35.7896727,8.12450909 38.5722182,10.9070545 38.5722182,14.3390545 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    points: "36.8512727 32.5208727 53.828 32.5208727 64.5334545 55.7557818 0.181454545 55.7557818 10.8869091 32.5208727 27.8643636 32.5208727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.96,32.5208727 C19.96,32.5208727 21.4654545,36.4852364 15.536,36.4852364 C9.60654545,36.4852364 9.42472727,35.6939636 9.42472727,35.6939636",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6865455,55.7559273 C32.6865455,55.7559273 31.4065455,52.2068364 33.3825455,51.7108364 C34.6923636,51.3806545 36.9614545,51.1355636 38.3425455,51.0082909 C39.0698182,50.9406545 39.6981818,50.4795636 39.9803636,49.8061091 L41.0218182,47.3297455 C41.2778182,46.7210182 41.7789091,46.2497455 42.4029091,46.0344727 C44.5258182,45.3021091 49.4763636,43.5399273 50.8145455,42.5886545 C52.5316364,41.3675636 58.0269091,42.5741091 58.7709091,43.2497455",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6837091,42.4498182 L14.4189818,43.4461818 C14.9055273,43.6236364 15.4509818,43.524 15.8437091,43.1858182 L18.0029818,41.3247273 C18.4517091,40.9378182 19.1215273,40.956 19.5477091,41.3669091 L24.0829818,45.0621818 C24.2597091,45.2054545 24.4182545,45.3683636 24.5513455,45.5530909 C25.2066182,46.4629091 26.5971636,48.828 26.3178909,49.2156364 L25.1382545,50.8534545 C24.6684364,51.5043636 23.8022545,51.7283636 23.0764364,51.3850909 L20.3928,50.116 C20.2197091,50.0345455 20.0328,49.9858182 19.8422545,49.9734545 L12.1178909,49.4505455 C10.9433455,49.3712727 10.0648,48.3421818 10.1702545,47.1705455 L10.5273455,43.1843636 C10.5775273,42.6185455 11.1506182,42.2549091 11.6837091,42.4498182 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.308,32.9981091 L44.8585455,34.0984727 C44.5472727,35.2970182 45.0330909,36.5610182 46.0665455,37.2432 L47.2607273,38.0308364 C47.6112727,38.2621091 48.0541818,38.3064727 48.444,38.1479273 L50.6229091,37.2621091 C50.9203636,37.1406545 51.2541818,37.1501091 51.5443636,37.2861091 L53.1552727,38.0402909 C53.6316364,38.2635636 54.1916364,38.2148364 54.6221818,37.9130182 L55.9,37.0170182",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6290182,35.7914182 C37.7308364,36.2736 39.9824727,37.7157818 39.9824727,39.4212364 C39.9824727,41.5216 36.5686545,43.2234182 32.3577455,43.2234182 C28.1461091,43.2234182 24.7330182,41.5216 24.7330182,39.4212364 C24.7330182,37.7157818 26.9839273,36.2736 30.0864727,35.7914182",
    id: "Stroke-15"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group 17.dd971724327894ecdbb6818c2ce0ae0a.svg";
export { ForwardRef as ReactComponent };